<template>
    <section>
        <v-flex class="clsForMain" v-for="admin in Admins" :key="admin._id">
            <v-flex> <b>Center Id : </b> {{ admin.center_id }}</v-flex>
            <v-flex> <b>Center : </b> {{ admin.center_name }}</v-flex>
            <v-flex> <b>Admin Info Sync : </b> {{ admin.admin_last_sync | moment("DD-MM-YYYY") }} , {{ admin.admin_last_sync | moment("hh:mm:ss a") }} </v-flex>
            <v-flex> <b>Student List Sync : </b> {{ admin.students_last_sync | moment("DD-MM-YYYY") }} ,  {{ admin.students_last_sync | moment("hh:mm:ss a") }} </v-flex>
            <v-flex> <b>Exam Response Sync : </b> {{ admin.examresponses_last_sync | moment("DD-MM-YYYY") }} ,  {{ admin.examresponses_last_sync | moment("hh:mm:ss a") }}  </v-flex>
            <v-flex> <b>Result Sync Sync : </b> {{ admin.results_last_sync | moment("DD-MM-YYYY") }} ,  {{ admin.results_last_sync | moment("hh:mm:ss a") }}  </v-flex>
            <v-flex> <b>Subject Wise Result Sync : </b> {{ admin.subjectwise_last_sync | moment("DD-MM-YYYY") }} ,  {{ admin.subjectwise_last_sync | moment("hh:mm:ss a") }} </v-flex>
            <v-flex> <b>DB Zip Sync : </b> {{ admin.zip_last_added | moment("DD-MM-YYYY")}} ,  {{ admin.zip_last_added | moment("hh:mm:ss a") }}</v-flex>         
            <v-flex style="text-align: center;margin-top:18px;">
                <v-btn color='primary' round @click="OpenBackups(admin)">View Backups</v-btn>
                <v-btn color='primary' round @click="OpenAttendance(admin)">View Attendance</v-btn>
            </v-flex>
        </v-flex>
        <v-dialog v-model="dialog" persistent max-width="500">
            <v-card>
                <v-card-title class="headline grey lighten-3" primary-title>
                    <v-flex>Backups</v-flex>
                    <v-flex style="padding: 0px 20px;">
                        <v-btn style="float:right;" flat fab small  @click="CloseDialog">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                </v-card-title>
                <v-card-text>
                     <v-flex><b>Center</b> : {{ admin.center_name }}</v-flex>
                     <v-flex v-for="(backup,index) in Backups" :key="index">
                        {{ index + 1 }} .  {{ backup.Uploaded_Time | moment("DD-MM-YYYY") }} , {{ backup.Uploaded_Time | moment("hh:mm:ss a") }}
                        <a :href="Link(backup.File_Name)" target="_blank">Click Here To Download Zip</a>
                    </v-flex>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="attendance" persistent max-width="600">
            <v-card>
                <v-card-title class="headline grey lighten-3" primary-title>
                    <v-flex>Attendance</v-flex>
                    <v-flex style="padding: 0px 20px;">
                        <v-btn style="float:right;" flat fab small  @click="CloseDialog">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                </v-card-title>
                <v-card-text>
                     <v-flex><b>Center</b> : {{ admin.center_name }}</v-flex>
                     <v-flex v-for="(attendance,index) in Attendance_List" :key="index">
                        {{ index + 1 }} .  {{ attendance.session_date | moment("DD-MM-YYYY") }} , {{ attendance.session_date | moment("hh:mm a") }}
                            <v-flex style="margin: 0px 50px;">
                                <v-flex v-for="(link,index1) in attendance.attendance" :key="index1+'_'">
                                   {{ index1 + 1 }} . <a :href="Link(link)" target="_blank">Click Here To Download Attendance</a>
                                </v-flex>
                            </v-flex>
                    </v-flex>
                </v-card-text>
            </v-card>
        </v-dialog>
    </section>
</template>
<script>
import moment from 'moment';
export default {
    data(){
        return {

            Admins  : [],
            dialog  : false,
            Backups : [],
            admin   : {},
            attendance : false,
            Attendance_List : []
        }
    },
    computed:{

    },
    methods:{
        Link(Link){
            return `${this.$store.getters.GetProductionUrl}/${Link}`
        },
        OpenBackups(admin){
           
            this.Backups = admin['Backups']
            this.admin   = admin
            this.dialog  = true
        },
        CloseDialog(){
            
            this.Backups = []
            this.admin   = {}
            this.Attendance_List = []
            this.dialog  = false
            this.attendance = false
        },
        OpenAttendance(admin){

            this.admin   = admin 
            this.$eventHub.$emit("LOADING",'true')
            this.$http.post(`${this.$store.getters.GetProductionUrl}/admin/getattendance`,{"center_id" : this.admin['center_id']})
                .then(response =>{
                    
                    this.attendance = response && response['data'] && response['data']['response'] ? true : false
                    this.Attendance_List = response && response['data'] && response['data']['response'] ? response['data']['response'] : []
                    this.$eventHub.$emit("LOADING",'false')
                    response && response['data'] && response['data']['response'] ? {} : this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                })
                .catch(error =>{

                    this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                })
        }
    },
    mounted(){

        this.$http.post(`${this.$store.getters.GetProductionUrl}/admin/getadminlist`,{})
            .then(response =>{

                this.Admins = response && response['data'] && response['data']['response'] ? response['data']['response'] : []
                this.$eventHub.$emit("LOADING",'false')
            })
            .catch(error =>{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
            })
    }
}
</script>
<style scoped>
.clsForMain{
    width: 31.3%;
    padding: 15px;
    display: inline-block;
    margin: 8px;
    -webkit-box-shadow: 0 0 12px 1px rgba(0,0,0,.13);
    box-shadow: 0 0 12px 1px rgba(0,0,0,.13);
}
</style>